export default __webpack_public_path__ + "static/pfp-9d022196090d3aa4bb7cbbbe1148829e.png";